import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class GetPayoutList extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

          var request_data = JSON.stringify({
            "corridor": "bank",
            "session_id": "SESS_UWX2OXWDPURTHDVC4GERSTRXOWWGOIYL"
        }, null, 2);

        var response_data = JSON.stringify({
            "success": true,
            "data": [
                {
                    "locationId": "9100274",
                    "locationName": "UNITY SMALL FINANCE BANK LIMITED"
                }
            ],
            "message": "Payout list fetched successfully"
        }, null, 2);
      
        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                        <article class="docs-article" id="section-1">
                            <h1 class="docs-heading">Get Payout List</h1>
                            <section class="docs-intro">
                                <p>
                                    Returns the list of available payout institutions for the selected
                                    destination country and payout corridor.
                                </p>

                                <p>
                                    This API provides the financial institutions, banks, wallets,
                                    or payout providers available for the selected transaction route.
                                    The institution selected from this API must be used in subsequent
                                    APIs such as
                                    <span class="highlight"> Get Recipient Form</span>,
                                    <span class="highlight"> Get Branch Codes</span>,
                                    and
                                    <span class="highlight"> Make Payment</span>.
                                </p>

                                <p>
                                    The returned
                                    <span class="highlight"> locationId </span>
                                    identifies the selected payout institution and is required
                                    throughout the remainder of the transaction flow.
                                </p>
                            </section>
                        </article>

                        <article class="docs-article" id="section-2">
                            <header class="docs-header">
                                <h1 class="docs-heading">
                                    Get Payout List Reference
                                </h1>
                                <section class="docs-intro row">
                                    <div class="col-lg-6 col-12">
                                    <p>
                                        This POST API returns the available payout institutions for the selected
                                        destination country and payout corridor. The selected institution will
                                        be used during beneficiary creation and payment processing.
                                    </p>
                                    <div class="alert alert-info mt-3">
                                        <b>When to Use</b>
                                        <p class="mb-0">
                                            Call this API after successfully calculating exchange rates and
                                            before collecting beneficiary information.
                                        </p>
                                    </div>
                                        <section class="docs-section row" id="item-2-3">
                                            <h2 class="section-heading">Api Params</h2>
                                            <div class="col-lg-6 col-12">
                                                <div class="attributes">
                                                <div class="attributes-head">
                                                    <h4>Request Attributes</h4>
                                                </div>

                                                <div class="attributes-contents">

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">corridor</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br />
                                                        Selected payout corridor returned by the
                                                        Get Available Corridors API.
                                                    </p>

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">session_id</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br />
                                                        Transaction Session ID returned by the
                                                        Get Available Corridors API.
                                                    </p>

                                                </div>
                                                </div>
                                                <div class="attributes">
                                                    <div class="attributes-head">
                                                        <h4>Response Parameters</h4>
                                                    </div>

                                                    <div class="attributes-contents">

                                                        <p>

                                                            <b>locationId</b> :
                                                            <span class="highlight"> String</span><br />
                                                            Institution identifier required for downstream APIs.

                                                            <br /><br />

                                                            <b>locationName</b> :
                                                            <span class="highlight"> String</span><br />
                                                            Display name of the payout institution.

                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </section>


                                    </div>
                                    <div class="col-lg-6 col-12 mr-4">
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">Api Endpoint</p>
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        Method : POST <br />
                                                        &nbsp;Endpoint: /v2/merchant/get-payout-list
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">PRE-REQUEST API KEY</p>
                                                <svg style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, request_data);
                                                 }}
                                                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8" />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        {request_data}

                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox copybox-response mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">RESPONSE</p>
                                                <svg 
                                                style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, response_data);
                                                 }} 
                                                 width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8"
                                                    />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code id="copy-txt" class="copybox-code ">
                                                        {response_data}
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                </section>


                            </header>

                        </article>
                        
                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Business Rules</h2>

                                <table class="table table-bordered table-white">
                                    <thead>
                                        <tr>
                                            <th>Rule</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td>Institution Selection</td>
                                            <td>
                                                A payout institution must be selected.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Location ID</td>
                                            <td>
                                                The selected <code>locationId</code> must be used in
                                                Get Recipient Form, Get Branch Codes, and Make Payment.
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Session Validation</td>
                                            <td>
                                                The same <code>session_id</code> must be reused throughout
                                                the transaction.
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">Comments</h2>

                                <ul>
                                    <li>Do not hardcode payout institutions.</li>
                                    <li>Always use the latest institution list returned by the API.</li>
                                    <li>Store the selected <code>locationId</code> for downstream APIs.</li>
                                </ul>

                            </section>
                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-calculate-rates"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>
                                                &nbsp;Calculate Exchange Rates
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-get-recipient-form"
                                            >
                                                Get Recipient Form
                                                &nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}